import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { CoreModule, DialogComponent, FormComponent } from '@toevla-webapplications/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { IvvaStore } from '../../../../store/store.model';
import { takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { FilterConfig } from '../../../../shared/filter-config.model';
import OFFERS_ACTIONS from '../../../../store/offers/offers.actions';

@Component({
    selector: 'ivva-filter-box',
    templateUrl: './filter-box.component.html',
    styleUrls: ['./filter-box.component.scss'],
    imports: [TranslateModule, CoreModule, DialogComponent]
})
export class FilterBoxComponent extends FormComponent implements OnInit {
	@Input()
	config: FilterConfig;

	showInfo = signal(false);

	private readonly fb = inject(FormBuilder);
	private readonly store = inject(Store<IvvaStore>);

	ngOnInit() {
		this.form = this.generateForm();

		this.form.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe((value) => {
			const list = [];

			for (const key in value) {
				if (value[key]) {
					list.push(key);
				}
			}

			const filters = { [this.config.name]: list };
			this.store.next(OFFERS_ACTIONS.setFilters({ filters }));
		});

		this.store
			.select('offers', 'filters')
			.pipe(takeUntil(this.destroyed$))
			.subscribe((filters) => {
				if (filters[this.config.name]) {
					this.config.options.forEach((o) => {
						const ctrl = this.form.get(o);
						const found = !!filters[this.config.name].find((item: string) => item === o);

						if (ctrl) {
							ctrl.setValue(found, { onlySelf: true });
						}
					});
				}
			});
	}

	private generateForm(): FormGroup {
		const controls: any = {};

		this.config.options.forEach((o) => (controls[o] = this.fb.control(false)));

		return this.fb.group(controls);
	}
}
